import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSidebarRightShow24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 5.5h-3v13h3a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 19 5.5m-14 0h9.5v13H5A1.5 1.5 0 0 1 3.5 17V7A1.5 1.5 0 0 1 5 5.5M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm5.422 5.702a.75.75 0 1 0-1.06-1.06L6.533 11.47l-.53.53.53.53 2.829 2.829a.75.75 0 1 0 1.06-1.06L8.124 12z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow24);
